// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__iQndG","log":"ModalInventoryLogs_log__2KMrN","date":"ModalInventoryLogs_date__2qQij","userName":"ModalInventoryLogs_userName__3hbGX"};